import {useNavigate} from "react-router-dom";
import styled from "@emotion/styled/macro";
import {PropsWithChildren, useContext, useState} from "react";
import {useVscContext, VscReactContext} from "./VscReactContext";
import {VscContext} from "./ContentRendererJSX";
import VscContentContext from "./VscContentContext";
import {useVscCurrentValue} from "./ContentComponent";
import BigScreenWebPage from "../../unreal/BigScreenWebPage";
import {VscVideoPlayer} from "../video/VscVideoPlayer";
import assertDefined from "../../errors/assertDefined";
import {useVisualizerSession} from "../visualizer/VscVisualizerSession";
import {useStateId} from "../../hooks/useStateId";
import useStation from "../../data/stationSource";


export const VscButton = styled.button`
  /* Button styles */

  
  :active .primary {
    color: #ffffff;
  }
  &.active .primary {
    color: #ffffff;
  }
    :active,&.active {
      background-color: var(--primary-color);
      * {
        color: #fff;
      }

    }
    justify-content: center;

    &.selected {
      transition: background-color 0.2s;

      //background: linear-gradient(180deg, var(--primary-color-light, transparent) 0%, var(--primary-color, transparent) 100%);
      background-color: var(--primary-color);
    }
    &.selected * {
      transition: color 0.2s;
      color: #fff;
    }
    padding: 0;

    background: white;

    font-family: var(--font-name, 'Times Roman');
    border: none;

    border-radius: 16px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    display: flex;
    gap:8px;
    flex-direction: column;
    align-items: center;
    p {

      /* body3 */
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;

    }
    h3 {
      color: var(--secondary-color, transparent);
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 33px;
      /* identical to box height */
    }
    .primary {
      color: var(--primary-color, transparent);
    }
    .text-accent {
      color: var(--accent-text-color);
    }

    h4 {
      color: var(--accent-text-color, transparent);
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 27px;
    }
    .secondary {
      color: var(--secondary-color, transparent);
    }
  
`
const VscButtonContainerDiv = styled.div`

  height:100%;

  margin: 40px;
  justify-content: center;
justify-items:center;
  
  align-content:center;
  
  &.flex {
    display: flex;
    gap: 32px;

    flex-basis: 100%;
    flex-grow: 1;
    box-sizing: border-box;

  }
  &.grid {
    gap: 32px;

    display:grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    > * {
      
      max-width:100%;
      
    }
  }
  &.wrap {
    flex-wrap: wrap;
  }

`

export const VscFlexRow = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: center;
  gap:32px;

`
const VscFlexDiv = styled.div`

  display:flex;
  flex-direction:column;
  gap:32px;
  height:100%;
  justify-content:center;
`
export const VscFlexRowLayout: React.FC<PropsWithChildren<{className?:string}>> = (props) => {
  const { className } = props;
  return <VscFlexDiv className={className ?? "sm"}>{ props.children }</VscFlexDiv>

}
export const VscSimpleLayout: React.FC<PropsWithChildren<{className?:string, wrap?:boolean, flex?: boolean, type?: string}>> = (props) => {


  const classes: string[] = ["vsc-button-container"];
  if (props.className) {
    classes.push(props.className);
  }
  if (props.wrap) {
    classes.push("wrap")
  }
  if (props.flex) {
    classes.push("flex");
  } else {
    classes.push("grid");
  }
  return <VscButtonContainerDiv className={classes.join(' ')}>
    { props.children }
  </VscButtonContainerDiv>
}

export const VscLinkButton: React.FC<PropsWithChildren<{url:string, className?: string}>> = ({url, className, children}) => {

  const navigate = useNavigate();
  const vscContext = useContext(VscReactContext);
  if (vscContext === null) throw "Invalid context";

  return <VscButton className={className} onClick={() => navigate(vscContext.getNavigateContentUri(url), { relative: "route"})}>
    {children}
  </VscButton>


}
async function fetchSalesCenterUrl(endpoint:string, environment:string) {

  const fetchResult = await fetch(`${endpoint}config/${environment}/serverUrl`);
  const fetchJson = await fetchResult.json();

  return fetchJson.server;
}
export const VscSalesCenterLinkButton : React.FC<PropsWithChildren<{environment:string, salesCenter:string, className?:string}>> = ({environment, salesCenter, className, children}) => {
  const vscContext = useContext(VscReactContext);
  if (vscContext === null) throw "Invalid context";

  const stationId = useStation();

  return <VscButton className={className} onClick={async () => {

    const salesCenterUrl = await fetchSalesCenterUrl(vscContext.serverUri, environment);
    (window as any).location = salesCenterUrl + "sc/" + salesCenter + "/" + stationId;
    console.log(salesCenterUrl);

  }
  }>
    {children}
  </VscButton>

}

export const VscVideoButton: React.FC<PropsWithChildren<{value:string, video:string, title:string, looping?: boolean}>> = (props) => {
  const { value, video, title, looping } = props;
  const vscContext = useVscContext();
  const currentValue = useVscCurrentValue();

  const isActive = value === currentValue;
  assertDefined({value, video, title});
  return <VscMediaButton value={value} onClick={() => vscContext.setValue(value)}>
    { props.children }
    { isActive && <VscVideoPlayer videoName={video} videoTitle={title} looping={looping} /> }
  </VscMediaButton>
}

export function getImageContentUrl(vscContext: VscContext, url:string) {
  return vscContext.getVisualizerContentUri(`StaticContent.html?shared=global&image=${vscContext.getVisualizerContentUri(url)}`);
}


export const VscDefaultButton: React.FC<{page:string, title:string, subtitle:string}> = ({page, title, subtitle}) => {
  const contentPage = useContext(VscContentContext);

  return <VscLinkButton url={page}>
    <h4 className={"text-accent"}>{title}</h4>
    <p>{subtitle}</p>

  </VscLinkButton>

}

export const VscImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {


  const vscContext = useContext(VscReactContext)!;
  const uri = vscContext.getHtmlContentUri(props.src!);

  return <img {...props} src={uri}/>
}
export const VscBigScreenImage: React.FC<{url:string}> = ({url}) => {
  const vscContext = useVscContext();
  const contentUrl = getImageContentUrl(vscContext, url);
  return <BigScreenWebPage uri={contentUrl} />;
}
export const VscBigScreenWebPage: React.FC<{url:string}> = ({url}) => {
  const vscContext = useVscContext();
  const contentUrl = !url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("chrome:") ? vscContext.getVisualizerContentUri(url) : url;
  //const contentUrl = "chrome:about";
  return <BigScreenWebPage uri={contentUrl} />;
}
export const VscDefaultImage: React.FC<{url:string}> = ({url}) => {
  const currentValue = useVscCurrentValue();
  if (currentValue !== "") return null;
  return <VscBigScreenImage url={url} />;
}
export const VscDefaultVideo: React.FC<{file: string, title: string, looping?: boolean, session?: string}> = (props) => {
  const { file, title, session, looping } = props;
  const currentValue = useVscCurrentValue();
  if (currentValue !== "") return null;
  return <VscVideoPlayer videoName={file} videoTitle={title} session={session} looping={looping}/>;

}
const VscButtonImageLayoutDiv = styled.div`
  width:100%;
  height:100%;
  display: flex;
  flex-direction: column;
  text-align:left;
  align-items: flex-start;
  justify-content: space-between;
  img {
    width: 100%;
    height: calc(100% - 100px);
    border-radius: 16px 16px 0px 0px;
  }
  div {
    margin-top: 16px;
    margin-bottom:16px;
  }

`;
export const VscButtonImageLayout: React.FC<PropsWithChildren<{image:string}>> = (props) => {
  const { image } = props;
  return <VscButtonImageLayoutDiv><VscImage src={image} />
  <div>
    { props.children }
  </div></VscButtonImageLayoutDiv>;

};
export const VscWebButton: React.FC<PropsWithChildren<{value:string, url:string, size?: string}>> = (props) => {
  const vscContext = useContext(VscReactContext)!;
  const {value, url} = props;

  const currentValue = useVscCurrentValue();


  return <VscMediaButton value={value} size={props.size} onClick={() => vscContext.setValue(value)}>
    { props.children }
    { currentValue === value && <VscBigScreenWebPage url={url} /> }

  </VscMediaButton>
}
export const VscImageButton: React.FC<PropsWithChildren<{value:string, url: string, size?: string}>> = (props) => {
  const vscContext = useContext(VscReactContext)!;
  const {value, url} = props;

  const currentValue = useVscCurrentValue();


  return <VscMediaButton value={value} size={props.size} onClick={() => vscContext.setValue(value) }
  >
    { props.children }
    { currentValue === value && <VscBigScreenImage url={url} /> }

  </VscMediaButton>
}
export const VscMediaButton: React.FC<PropsWithChildren<{value:string, onClick: () => void, size?: string}>> = ({value, onClick, children, size}) => {

  const currentValue = useVscCurrentValue();

  const classes = [size ?? "lg"];
  if (currentValue === value) {
    classes.push("selected");
  }
  return <VscButton className={classes.join(" ")} onClick={onClick}>{children}</VscButton>
}


